var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as cn from "classnames";
import * as React from "react";
import * as styles from "./styles.css";
var Container = function (_a) {
    var children = _a.children, _b = _a.element, element = _b === void 0 ? "div" : _b, className = _a.className, rest = __rest(_a, ["children", "element", "className"]);
    var Component = element;
    return (React.createElement(Component, __assign({}, rest, { className: cn(styles.container, className) }), children));
};
export default Container;



//////////////////
// WEBPACK FOOTER
// ./app/shared/components/container/index.tsx
// module id = f+9y
// module chunks = 2